import React, { Component } from 'react';
import { Icon, Tabs, Spin, Table, Button, Tooltip, message, Input, Modal } from 'antd'
import moment from 'moment';
import './referral.scss';
import ReferralQueryFrom from './components/referralQueryFrom';
import EditTable from '@/components/editTable/index';
import ReferralPatient from './referralPatient';
import receivePatient from "@/assets/image/receivePatient.png";
import leaveHospital from "@/assets/image/leaveHospital.png";
import returnReferral from "@/assets/image/returnReferral.png";
import { getCommonColumnInfoFn,requestErrorLog } from '@/common/util';
import { getReferredData, ApplyReferred, ReceiveReferral, CompleteDischarged, referralMsgNotice } from '@/request/api';

const { TextArea } = Input;
const { TabPane } = Tabs;
class ReferralConsult extends Component {
      constructor(props) {
            super(props);
            this.state = {
                  percent: 0,
                  showKey: '1',
                  refreshTimeNum: 0,
                  departmentList: [],//申请科室
                  showColumn: false, //编辑表头,
                  RowCount: 0,
                  PageNo: 1,
                  PageSize: 10,
                  rowData: [],
                  selectedRowKeys: [],
                  selectedRows: [],
                  referralColumn: [],
                  backreturndetail: '',
                  initReferralColumn: [
                        {
                              title: '序号',
                              dataIndex: 'title',
                              key: 'title',
                              width: 80,
                              align: 'center',
                              isShow: true,  //表头列合
                              render: (text, record, index) => {  //生成序号
                                    return (
                                          <span>{(this.state.PageNo - 1) * 10 + (index + 1)}</span>
                                    )
                              },
                        },
                        {
                              title: "转诊进程",
                              dataIndex: "REFERRAL_PROCESS_NAME",
                              key: "REFERRAL_PROCESS_NAME",
                              align: 'center',
                              width: 100,
                              isShow: true,
                              render: exam => <span
                                    style={{ color: (exam === '已接收' ? '#0FA7E9' : (exam === '已出院' ? '#3CBA61' : (exam === '已退回' ? '#F04249' : '#000'))) }}>{exam}</span>
                        },
                        {
                              title: "姓名",
                              dataIndex: "NAME",
                              key: "NAME",
                              align: 'center',
                              width: 120,
                              isShow: true,
                              ellipsis: true,
                              render: (text) => {
                                    return (
                                          <Tooltip placement="topLeft" title={text}>
                                                <span>{text}</span>
                                          </Tooltip>
                                    )
                              }
                        },
                        {
                              title: "性别",
                              dataIndex: "SEX_NAME",
                              key: "SEX_NAME",
                              align: 'center',
                              width: 80,
                              isShow: true,
                        },
                        {
                              title: "年龄",
                              dataIndex: "AgeDisPlay",
                              key: "AgeDisPlay",
                              align: 'center',
                              width: 80,
                              isShow: true,
                        },
                        {
                              title: "出生日期",
                              dataIndex: "BIRTHDAY",
                              key: "BIRTHDAY",
                              align: 'center',
                              width: 110,
                              isShow: true,
                              render: (val) => (
                                    <span>
                                          {val && moment(val).format("YYYY-MM-DD")}
                                    </span>
                              ),
                        },
                        {
                              title: "手机号",
                              dataIndex: "CONTACT_TEL",
                              key: "CONTACT_TEL",
                              align: 'center',
                              width: 120,
                              isShow: true
                        },
                        {
                              title: "转诊编号",
                              dataIndex: "REFERRAL_UID",
                              key: "REFERRAL_UID",
                              align: 'center',
                              width: 120,
                              isShow: true,
                        },
                        {
                              title: "申请转诊医院",
                              dataIndex: "REFERRAL_HOSPITAL_NAME",
                              key: "REFERRAL_HOSPITAL_NAME",
                              align: 'center',
                              width: 120,
                              isShow: true,
                              ellipsis: true,
                              render: (text) => {
                                    return (
                                          <Tooltip placement="topLeft" title={text}>
                                                <span>{text}</span>
                                          </Tooltip>
                                    )
                              }
                        },
                        {
                              title: "申请科室",
                              dataIndex: "REQ_DEPT_NAME",
                              key: "REQ_DEPT_NAME",
                              align: 'center',
                              width: 120,
                              isShow: true,
                              ellipsis: true,
                              render: (text) => {
                                    return (
                                          <Tooltip placement="topLeft" title={text}>
                                                <span>{text}</span>
                                          </Tooltip>
                                    )
                              }
                        },
                        {
                              title: "申请医生",
                              dataIndex: "REQ_DOCTOR_NAME",
                              key: "REQ_DOCTOR_NAME",
                              align: 'center',
                              width: 100,
                              isShow: true,
                        },
                        {
                              title: "申请转诊时间",
                              dataIndex: "APPLY_REFERRAL_DATE",
                              key: "APPLY_REFERRAL_DATE",
                              align: 'center',
                              width: 160,
                              isShow: true,
                              sorter: (a, b) => new Date(a.APPLY_REFERRAL_DATE).getTime() - new Date(b.APPLY_REFERRAL_DATE).getTime(),
                              render: (val) => (
                                    <span>
                                          {val && moment(val).format("YYYY-MM-DD")}
                                    </span>
                              ),
                        },
                  ],
                  isModalVisible: false,
                  backreturnvisible: false,
            }

      }
      componentDidMount() {
            this.queryReferralData()
            this.handleTabKey('1')
      }
      handleTabKey = (key) => { // 切换tabs
            //第一种情况表头
            let tabH1 =
                  [...this.state.initReferralColumn,
                  {
                        title: "预计转诊时间",
                        dataIndex: "EXPECT_REFERRAL_DATE",
                        key: "EXPECT_REFERRAL_DATE",
                        align: 'center',
                        width: 160,
                        isShow: true,
                        sorter: (a, b) => new Date(a.EXPECT_REFERRAL_DATE).getTime() - new Date(b.EXPECT_REFERRAL_DATE).getTime(),
                        render: (val) => (
                              <span>
                                    {val && moment(val).format("YYYY-MM-DD")}
                              </span>
                        ),
                  },
                  ]
            //第二种情况表头
            let tabH2 = [...this.state.initReferralColumn, {
                  title: "预计转诊时间",
                  dataIndex: "EXPECT_REFERRAL_DATE",
                  key: "EXPECT_REFERRAL_DATE",
                  align: 'center',
                  width: 160,
                  isShow: true,
                  sorter: (a, b) => new Date(a.EXPECT_REFERRAL_DATE).getTime() - new Date(b.EXPECT_REFERRAL_DATE).getTime(),
                  render: (val) => (
                        <span>
                              {val && moment(val).format("YYYY-MM-DD")}
                        </span>
                  ),
            }, {
                  title: "接收患者时间",
                  dataIndex: "RECEIVE_DATE",
                  key: "RECEIVE_DATE",
                  align: 'center',
                  width: 120,
                  isShow: true,
                  ellipsis: true,
                  render: (text) => {
                        return (
                              <Tooltip placement="topLeft" title={text}>
                                    <span>{text && moment(text).format("YYYY-MM-DD")}</span>
                              </Tooltip>
                        )
                  }
            }]
            //第三种情况表头
            let tabH3 = [
                  ...this.state.initReferralColumn, {
                        title: "接收患者时间",
                        dataIndex: "RECEIVE_DATE",
                        key: "RECEIVE_DATE",
                        align: 'center',
                        width: 120,
                        isShow: true,
                        ellipsis: true,
                        render: (text) => {
                              return (
                                    <Tooltip placement="topLeft" title={text}>
                                          <span>{text && moment(text).format("YYYY-MM-DD")}</span>
                                    </Tooltip>
                              )
                        }
                  }, {
                        title: "患者出院时间",
                        dataIndex: "DISCHARGE_DATE",
                        key: "DISCHARGE_DATE",
                        align: 'center',
                        width: 120,
                        isShow: true,
                        ellipsis: true,
                        render: (text) => {
                              return (
                                    <Tooltip placement="topLeft" title={text}>
                                          <span>{text && moment(text).format("YYYY-MM-DD")}</span>
                                    </Tooltip>
                              )
                        }
                  }
            ]
            //每次做切换时把表头信息设置进localStorage里边
            let referralColumnNew = []
            if (key === '1') {
                  referralColumnNew = getCommonColumnInfoFn(tabH1, localStorage.getItem("referralConsultSetting1") ? JSON.parse(localStorage.getItem("referralConsultSetting1")) : tabH1, 'referralConsultSetting1')
            } else if (key === '2') {
                  referralColumnNew = getCommonColumnInfoFn(tabH2, localStorage.getItem("referralConsultSetting2") ? JSON.parse(localStorage.getItem("referralConsultSetting2")) : tabH2, 'referralConsultSetting2')
            } else {
                  referralColumnNew = getCommonColumnInfoFn(tabH3, localStorage.getItem("referralConsultSetting3") ? JSON.parse(localStorage.getItem("referralConsultSetting3")) : tabH3, 'referralConsultSetting3')
            }
            this.setState({
                  showKey: key,
                  tabH1,
                  tabH2,
                  tabH3,
                  referralColumn: referralColumnNew,
                  PageNo: 1,
                  PageSize: 10,
                  rowData: [],
                  selectedRowKeys: []
            }, () => {
                  this.queryReferralData();//切换表格时更新列表数据
            });
      };
      handleHeader = () => { // 点击表头
            this.setState({
                  showColumn: true
            });
      }
      //获取、更新表头设置
      getCommonColumnInfo = (newTabData) => {
            //getCommonColumnInfoFn(改前的表头，改后的表头，存到localstrage里边的类型)
            let referralColumn = getCommonColumnInfoFn(this.state.showKey === '1' ? this.state.tabH1 : this.state.showKey === '2' ? this.state.tabH2 : this.state.tabH3, newTabData, 'referralConsultSetting' + this.state.showKey)
            this.setState({
                  referralColumn,
            })
      }
      resetQueryList = () => { //查询重置页码为1
            this.setState({
                  PageNo: 1,
                  PageSize: 10,
                  rowData: [],
                  selectedRowKeys: []
            }, () => {
                  this.queryReferralData()
            })
      }
      queryReferralData = () => { //获取列表数据
            const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
            this.refs.referralFormRef.validateFields((err, values) => {
                  if (!err) {
                        if (values.startTime > values.endTime) {
                              message.error('开始时间不得大于结束时间')
                              return;
                        }
                        let param = {
                              ...values,
                              Type: "ReferredData",
                              hospital_Code: userInfo.HOSPITAL_CODE,//所属医院
                              Referral_Process: this.state.showKey === '1' ? '0' : this.state.showKey === '2' ? '1' : '2',//查询类型(0:未接收，1：已接收，2：已出院)
                              hospitalItemDateTime: [moment(values.startTime).format('YYYY-MM-DD'), moment(values.endTime).format('YYYY-MM-DD')],
                              Req_Hospital_code: values.Req_Hospital_code,
                              Paitent_Id: values.Referral_Uid,
                              PageNo: this.state.PageNo,//页数
                              PageSize: this.state.PageSize//条数
                        }
                        getReferredData(param).then((res) => {
                              if (res && res.Status === 1) {
                                    // 获取列表数据及总条数
                                    this.setState({
                                          tabsloading: false,
                                          referralData: res.Result,
                                          RowCount: res.ResponseModel.RowCount
                                    })
                              }else{
                                    requestErrorLog('', '患者转诊-获取列表数据报错', 0,true)
                              }
                        })
                  }
            })
      }
      handleChangeReset = () => { //重置
            this.refs.referralFormRef.resetFields();
      }
      onSelectChange = (selectedRowKeys, selectedRows) => { //指定选中项的 key 数组
            this.setState({
                  selectedRowKeys,
                  rowData: selectedRows,
            })
      }
      onClickRow = (record) => {  //单击行事件 
            let peferralUid = []
            peferralUid.push(record.REFERRAL_UID);
            this.setState({
                  selectedRowKeys: peferralUid,
                  rowData: [record]
            })
      }
      seeInformation = () => {//查看信息
            if (this.state.selectedRowKeys.length !== 1) {
                  message.warn('请选择一个患者进行操作')
                  return;
            }
            this.setState({
                  isModalVisible: true,
                  clickType: "See",
            });
      }
      acceptPatients = () => {//接收患者
            if (this.state.selectedRowKeys.length === 0) {
                  message.warn('请选择患者')
                  return;
            } else {
                  let keys = this.state.selectedRowKeys
                  let param = {
                        Type: "ReceiveReferral",
                        REFERRAL_UID: keys.toString()
                  }
                  ReceiveReferral(param).then((res) => {
                        if (res && res.Status === 1) {
                              message.success('接收成功')
                              this.resetQueryList()
                        } else {
                              requestErrorLog('', '患者转诊-接收患者报错', 0,true)
                              message.error('接收失败')
                        }
                  })
            }
      }
      completeDischarge = () => {//完成出院
            if (this.state.selectedRowKeys.length === 0) {
                  message.warn('请选择患者')
                  return;
            } else {
                  let keys = this.state.selectedRowKeys
                  let param = {
                        Type: "CompleteDischarged",
                        REFERRAL_UID: keys.toString()
                  }
                  CompleteDischarged(param).then((res) => {
                        if (res && res.Status === 1) {
                              message.success('完成出院成功')
                              this.resetQueryList()
                        } else {
                              requestErrorLog('', '患者转诊-完成出院报错', 0,true)
                              message.error('完成出院失败')
                        }
                  })
            }
      }
      returnForReferral = () => {//退回转诊
            if (this.state.selectedRowKeys.length !== 1) {
                  message.warn('请选择一个患者进行退回')
                  return;
            }
            this.setState({
                  backreturnvisible: true,
            })
      }
      backreturnreason = () => {//退回转诊功能
            if (this.state.backreturndetail.trim() === "") {
                  message.warning("请填写退回病例原因");
                  return
            }
            const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
            const { rowData } = this.state
            let rowdata = rowData[0] ? rowData[0] : rowData
            var dateTime = moment(rowdata.APPLY_REFERRAL_DATE).format("YYYY-MM-DD HH:mm:ss")
            let param = [{
                  REFERRAL_UID: rowdata.REFERRAL_UID,
                  REFERRAL_HOSPITAL_CODE: userInfo.HOSPITAL_CODE,//转诊医院code
                  REFERRAL_HOSPITAL_NAME: userInfo.HOSPITAL_NAME,//转诊医院
                  APPLY_REFERRAL_DATE: dateTime,//申请转诊时间
                  REJECT_REASON: this.state.backreturndetail,//退回原因
            }]
            let returnObj = [{
                  MSG_CODE: '7',
                  MSG_DETAILED: `患者【${rowdata.NAME}】,退回原因：${this.state.backreturndetail}`,
                  EVENT_ID: rowdata.REFERRAL_UID,
                  HOSPITAL_CODE: rowdata.REQ_HOSPITAL_CODE
            }]
            ApplyReferred(param).then((res) => {
                  if (res && res.Status === 1) {
                        message.success('退回成功！')
                        referralMsgNotice(userInfo.HOSPITAL_CODE, returnObj)
                        this.setState({
                              backreturnvisible: false,
                              backreturndetail: '',
                        }, this.resetQueryList())
                  }
                  else {
                        requestErrorLog('', '患者转诊-退回转诊报错', 0,true)
                        message.error('退回失败！')
                  }
            })
      }
      onChangePage = (page, PageSize) => { //切换页码时重新赋值
            this.setState({
                  PageNo: page,
                  tabsloading: true,
            }, () => {
                  this.queryReferralData()
            })
      }
      handleInputChange = (event) => { // 退回原因
            this.setState({ backreturndetail: event.target.value });
      }
      render() {
            const { showKey, referralColumn, showColumn, referralData, selectedRowKeys, isModalVisible, rowData, clickType, backreturnvisible } = this.state
            return (
                  <div>
                        <div className="tabs_wrap">
                              <div onClick={() => this.seeInformation()}>
                                    <Icon type="monitor" className="icon" />
                                    <p>查看信息</p>
                              </div>
                              {
                                    showKey === '1' ?
                                          <div onClick={() => this.acceptPatients()}>
                                                <img src={receivePatient} alt='' style={{ width: '33px', marginLeft: '27px', }}></img>
                                                <p>接收患者</p>
                                          </div> : null
                              }
                              {
                                    showKey === '2' ?
                                          <div onClick={() => this.completeDischarge()}>
                                                <img src={leaveHospital} alt='' style={{ width: '33px', marginLeft: '27px', }}></img>
                                                <p>完成出院</p>
                                          </div> : null
                              }
                              {
                                    showKey === '1' ?
                                          <div onClick={() => this.returnForReferral()}>
                                                <img src={returnReferral} alt='' style={{ width: '33px', marginLeft: '27px', }}></img>
                                                <p>退回转诊</p>
                                          </div> : null
                              }
                        </div>
                        <div className='selectReferralBtn'>
                              <ReferralQueryFrom
                                    ref='referralFormRef'
                                    queryReferralData={this.queryReferralData}
                                    onRef={(ref) => {
                                          this.ReferralQueryFrom = ref
                                    }} />
                              <Button onClick={this.resetQueryList}>查询</Button>
                              <Button onClick={this.handleChangeReset} style={{ marginLeft: '10px' }}>重置</Button>
                        </div>
                        <div className="eleWrap applyTd">
                              <Tabs activeKey={showKey} type="card" onChange={this.handleTabKey}>
                                    <TabPane key="1" tab='待接收'>
                                          <Spin size="large" spinning={false} tip="Loading...">
                                                <Table
                                                      columns={referralColumn}
                                                      dataSource={referralData}
                                                      rowKey={(record) => record.REFERRAL_UID} //需要修改为唯一的ID！
                                                      pagination={{
                                                            total: this.state.RowCount,
                                                            current: this.state.PageNo,
                                                            onChange: this.onChangePage,
                                                      }}
                                                      rowSelection={{
                                                            selectedRowKeys,
                                                            onChange: this.onSelectChange,
                                                      }}
                                                      onRow={record => {
                                                            return {
                                                                  onClick: e => { this.onClickRow(record) },//点击行
                                                            }
                                                      }}
                                                      onHeaderRow={column => {
                                                            return {
                                                                  onDoubleClick: e => this.handleHeader(column)//修改表头
                                                            }
                                                      }}
                                                />
                                          </Spin>
                                    </TabPane>
                                    <TabPane key="2" tab='已接收'>
                                          <Spin size="large" spinning={false} tip="Loading...">
                                                <Table
                                                      columns={referralColumn}
                                                      dataSource={referralData}
                                                      rowKey={(record) => record.REFERRAL_UID} //需要修改为唯一的ID！
                                                      rowSelection={{
                                                            selectedRowKeys,
                                                            onChange: this.onSelectChange,
                                                      }}
                                                      pagination={{
                                                            total: this.state.RowCount,
                                                            current: this.state.PageNo,
                                                            onChange: this.onChangePage,
                                                      }}
                                                      onRow={record => {
                                                            return {
                                                                  onClick: e => { this.onClickRow(record) },//点击行
                                                            }
                                                      }}
                                                      onHeaderRow={column => {
                                                            return {
                                                                  onDoubleClick: e => this.handleHeader(column)//修改表头
                                                            }
                                                      }}
                                                />
                                          </Spin>
                                    </TabPane>
                                    <TabPane key="3" tab='已出院'>
                                          <Spin size="large" spinning={false} tip="Loading...">
                                                <Table
                                                      columns={referralColumn}
                                                      dataSource={referralData}
                                                      rowKey={(record) => record.REFERRAL_UID} //需要修改为唯一的ID！
                                                      rowSelection={{
                                                            selectedRowKeys,
                                                            onChange: this.onSelectChange,
                                                      }}
                                                      pagination={{
                                                            total: this.state.RowCount,
                                                            current: this.state.PageNo,
                                                            onChange: this.onChangePage,
                                                      }}
                                                      onRow={record => {
                                                            return {
                                                                  onClick: e => { this.onClickRow(record) },//点击行
                                                            }
                                                      }}
                                                      onHeaderRow={column => {
                                                            return {
                                                                  onDoubleClick: e => this.handleHeader(column)//修改表头
                                                            }
                                                      }}
                                                />
                                          </Spin>
                                    </TabPane>
                              </Tabs>
                        </div>
                        {/* 编辑表头 */}
                        {
                              showColumn ?
                                    <EditTable
                                          visible={showColumn}
                                          setTabData={JSON.parse(localStorage.getItem("referralConsultSetting" + showKey)) || this.state.referralColumn}
                                          updateParent={this.getCommonColumnInfo}
                                          onRef={(ref) => { this.setState({ showColumn: ref.showColumn }) }} /> : null
                        }
                        {/* 新建转诊 */}
                        {
                              isModalVisible ?
                                    <ReferralPatient
                                          visible={isModalVisible}
                                          clickType={clickType}
                                          rowData={rowData[0] ? rowData[0] : rowData}
                                          onRef={(ref) => {
                                                this.setState({
                                                      isModalVisible: ref.isModalVisible,
                                                });
                                          }} /> : null
                        }
                        {/* 退回病例原因 */}
                        {backreturnvisible ?
                              <Modal
                                    className="consulationH"
                                    width={440}
                                    title="退回病例"
                                    visible={backreturnvisible}
                                    footer={[
                                          <Button key="save" type="primary" onClick={this.backreturnreason}>
                                                确定
                                          </Button>,
                                          <Button key="exit" type="primary" onClick={() => {
                                                this.setState({
                                                      backreturnvisible: false
                                                })
                                          }}>
                                                取消
                                          </Button>
                                    ]}
                                    onCancel={() => {
                                          this.setState({
                                                backreturnvisible: false
                                          })
                                    }}                // 右上角的关闭按钮
                              >
                                    <div style={{ padding: '10px' }}>
                                          <span className="backreson">退回原因：
                                          </span>
                                          <TextArea maxLength={128} style={{ width: "320px" }} placeholder="请输入退回原因，最长不要超过128个字符" onChange={this.handleInputChange}
                                                defaultValue={this.state.backreturndetail} />

                                    </div>
                              </Modal> : null
                        }
                  </div>
            );
      }
}

export default ReferralConsult;